import { useState, useEffect } from 'react';
import { LandingPage } from './components/LandingPage';
import { PulseSpace } from './components/PulseSpace';
import { DemoSpace } from './components/DemoSpace';
import { TermsPage } from './components/TermsPage';
import { PrivacyPage } from './components/PrivacyPage';
import { CreditsPage } from './components/CreditsPage';

type Page = 'landing' | 'space' | 'demo' | 'terms' | 'privacy' | 'credits';

function getRoute(): { page: Page; spaceId?: string } {
  const path = window.location.pathname;
  if (path === '/demo') return { page: 'demo' };
  if (path === '/terms') return { page: 'terms' };
  if (path === '/privacy') return { page: 'privacy' };
  if (path === '/credits') return { page: 'credits' };
  const match = path.match(/^\/p\/([a-f0-9-]+)$/);
  if (match) return { page: 'space', spaceId: match[1] };
  return { page: 'landing' };
}

export function App() {
  const [route, setRoute] = useState(getRoute);

  useEffect(() => {
    const onPopState = () => setRoute(getRoute());
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  switch (route.page) {
    case 'demo': return <DemoSpace />;
    case 'terms': return <TermsPage />;
    case 'privacy': return <PrivacyPage />;
    case 'credits': return <CreditsPage />;
    case 'space': return route.spaceId ? <PulseSpace spaceId={route.spaceId} /> : <LandingPage />;
    default: return <LandingPage />;
  }
}
